export default "__VITE_ASSET__Boz0XE6J__"